(function ($) {
  $(function () {
    function updateHeaderHeight() {
      var totalHeight = $('header > .wp-block-group').outerHeight();
      document.documentElement.style.setProperty('--header-height', totalHeight + 'px');
    }

    // Initial calculation
    updateHeaderHeight();

    // Recalculate on window resize
    $(window).on('resize', function () {
      updateHeaderHeight();
    });
  });
})(jQuery);
